import { useInstance } from "@meraki-internal/react-dependency-injection";
import Carousel from "react-multi-carousel";
import { DataModelV2 } from "./data";

const responsive = {
    superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 4000, min: 3000 },
        items: 4
    },
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 3
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 2
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1
    }
};

export const OurStudentTestimonials: React.FC = () => {
    const data = useInstance(DataModelV2);


    return (
        <section className="section-content-block">

            <div className="container">

                <div className="row section-heading-wrapper">
                    <div className="col-lg-12 col-md-12 col-sm-12 text-center">
                        <h2>Impacting <span>Students</span></h2>
                        <h4>Here is what they have to say</h4>
                    </div>
                </div>

                <div className="row">
                    <div>
                        <Carousel
                            responsive={responsive}
                            infinite
                        >
                            {data.getShuffledTestimonials().map((t, i) => (
                                <div key={i} style={{ margin: 10 }}>
                                    <div className="testimony-layout-2">
                                        <p className="testimony-text">
                                            {t.testimonial}
                                        </p>
                                        <div className="testimony-info">
                                            <h4>{t.studentInfo.name}</h4>
                                            {t.studentInfo.grade !== 'parent' && (
                                                <h6>{t.club.name} ({t.studentInfo.grade} grade)</h6>
                                            )}
                                            {t.studentInfo.grade === 'parent' && (
                                                <h6>{t.club.name} (Parent)</h6>
                                            )}

                                        </div>
                                    </div>
                                </div>
                            ))}
                        </Carousel>
                    </div>

                </div>
            </div>
        </section>
    );
}
